export default function About() {
  return (
    <div data-testid="about-page" className="max-w-5xl mx-auto px-6 py-24">
      <p className="overline">Our Story</p>
      <h1 className="mt-2 font-serif text-5xl sm:text-6xl text-[#1e392a] tracking-tight leading-[1.05]">
        Rooted in ritual,<br />
        <em className="text-[#c36a4f]">bottled in glass.</em>
      </h1>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
        <div className="space-y-6 text-[#1a1b1a]/80 leading-relaxed">
          <p>
            ARIALOK began in a tiny kitchen in Kerala, where three generations of
            women stirred coconut oil over slow wood fires. What started as a home
            remedy is now our life's work — small-batch botanicals that honour the
            slow, deliberate ways of Ayurveda.
          </p>
          <p>
            Every bottle you hold is the result of relationships. With the farmers
            who grow our neem. With the craftsmen who blow our amber glass. With
            the women who inspect every batch before it leaves our workshop.
          </p>
          <p>
            We're proudly cruelty-free, plastic-free where possible, and obsessed
            with traceability. Because beauty shouldn't come at anyone's expense.
          </p>
        </div>
        <div className="bg-white border border-[#e6e2d8] rounded-md p-10">
          <p className="overline">Principles</p>
          <ul className="mt-6 space-y-6">
            {[
              { t: "Cold-pressed", d: "Under 40°C so nothing precious is lost." },
              { t: "Traceable", d: "One farm partner per hero ingredient." },
              { t: "Cruelty-free", d: "Never tested on animals. Ever." },
              { t: "Glass over plastic", d: "Because your rituals deserve better." },
            ].map((p) => (
              <li key={p.t}>
                <p className="font-serif text-2xl text-[#1e392a]">{p.t}</p>
                <p className="text-sm text-[#8a8d86] mt-1">{p.d}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
